import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import { IUser } from '../users/user';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { CustomLogger } from '../shared/custom-logger';
import { JwtHelperService } from '@auth0/angular-jwt';
import { PermissionService } from '../shared/permission-module/services/permission.service';


@Injectable()
export class AuthService {
  private authUrl = environment.authUrl;
  private headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  @Output() loggedIn: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private _http: HttpClient,
    private logger: CustomLogger,
    public jwtHelper: JwtHelperService,
    private permissionService: PermissionService
  ) {
    this.permissionService.add(this.getUserRole());
  }

  login(user: IUser): Observable<any> {
    let body = new HttpParams();
    body = body.set('_username', user.username);
    body = body.set('_password', user.password);
    return this._http.post<any>(this.authUrl, body, { headers: this.headers })
      .do(data => {
        this.onLoggedIn(data.token);
      })
      .catch(error => Observable.throw(error.error || 'Server error'))
  }

  logout(): void {
    this.permissionService.clearStore();
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('user');
    this.onLoggedOut();
  }

  onLoggedIn(token: string): void {
    const user = this.jwtHelper.decodeToken(token);
    sessionStorage.setItem('access_token', token);
    sessionStorage.setItem('user', JSON.stringify(user));
    this.permissionService.add(this.getUserRole());
    this.loggedIn.emit(true);
  }

  onLoggedOut(): void {
    this.loggedIn.emit(false);
  }

  getToken(): string {
    return sessionStorage.getItem('access_token');
  }

  getUser(): any {
    return JSON.parse(sessionStorage.getItem('user')) || null;
  }

  getUserRole() {
    const user = this.getUser();
    if (user) {
      return user.roles[0];
    } else {
      return null;
    }
  }

  isLoggedIn(): boolean {
    return !!sessionStorage.getItem('access_token');
  }

  getLoggedIn(): EventEmitter<boolean> {
    return this.loggedIn;
  }


}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts